import { useEffect, useState } from "react";

import { ConfigurationDto } from "@intelligems/ig-types";

import { useGetOrg } from "../../api/organizations/get-organization";
import { getIsSubscriptionActive } from "../MainApp/Utils/dialogHelpers";
import { getRemainingTrialDays } from "../Utils/helpers";

export const checkBooleanScope = (
  scope: string,
  configurations: ConfigurationDto[]
): boolean => {
  if (!scope) {
    return false;
  } else {
    const foundScope = configurations.find((config) => config.key === scope);
    if (!foundScope) {
      return false;
    } else {
      return foundScope.value;
    }
  }
};

export const checkNumberScope = (
  scope: string,
  configurations: ConfigurationDto[],
  currentValue: number
): boolean => {
  if (!scope) {
    return false;
  } else {
    const foundScope = configurations.find((config) => config.key === scope);
    if (!foundScope) {
      return false;
    } else {
      return foundScope.value <= currentValue;
    }
  }
};

export const checkSubscriptionStatus = (considerFreeTrial?: boolean) => {
  const organization = useGetOrg();

  const isSubscriptionActive = getIsSubscriptionActive(
    organization.data.org.organizationSubscriptions
  );

  return considerFreeTrial
    ? getRemainingTrialDays(
        organization.data.org.freeTrialExpiresAtTs,
        organization.data.org.createdAtTs
      ) > 0 || isSubscriptionActive
    : isSubscriptionActive;
};

export const checkAllScopes = (validations: boolean[]) => {
  return validations.every((validation) => validation);
};

export const checkAnyScope = (validations: boolean[]) => {
  return validations.some((validation) => validation);
};
